import { type FunctionComponent } from "react";

import { FooterVariant } from "scmp-app/components/app-footer";
import { sendGA4Tracking } from "scmp-app/components/tracking/google-analytics-4/apis";

import BlackFacebookIcon from "./black-facebook-icon.svg";
import BlackInstagramIcon from "./black-instagram-icon.svg";
import BlackLinkedinIcon from "./black-linkedin-icon.svg";
import BlackTwitterIcon from "./black-twitter-icon.svg";
import BlackYoutubeIcon from "./black-youtube-icon.svg";
import { FacebookUrl, InstagramUrl, LinkedinUrl, TwitterUrl, YoutubeUrl } from "./consts";
import { SocialMedia as SocialMediaEnum } from "./enums";
import { Container, IconContainer } from "./styles";
import WhiteFacebookIcon from "./white-facebook-icon.svg";
import WhiteInstagramIcon from "./white-instagram-icon.svg";
import WhiteLinkedinIcon from "./white-linkedin-icon.svg";
import WhiteTwitterIcon from "./white-twitter-icon.svg";
import WhiteYoutubeIcon from "./white-youtube-icon.svg";

export type Props = {
  className?: string;
  variant?: FooterVariant.Dark;
};

export const FooterSocialMedia: FunctionComponent<Props> = ({ className, variant }) => {
  const socialMediaMap = {
    [SocialMediaEnum.Facebook]: {
      blackIcon: BlackFacebookIcon,
      url: FacebookUrl,
      whiteIcon: WhiteFacebookIcon,
    },
    [SocialMediaEnum.Instagram]: {
      blackIcon: BlackInstagramIcon,
      url: InstagramUrl,
      whiteIcon: WhiteInstagramIcon,
    },
    [SocialMediaEnum.Linkedin]: {
      blackIcon: BlackLinkedinIcon,
      url: LinkedinUrl,
      whiteIcon: WhiteLinkedinIcon,
    },
    [SocialMediaEnum.Twitter]: {
      blackIcon: BlackTwitterIcon,
      url: TwitterUrl,
      whiteIcon: WhiteTwitterIcon,
    },
    [SocialMediaEnum.Youtube]: {
      blackIcon: BlackYoutubeIcon,
      url: YoutubeUrl,
      whiteIcon: WhiteYoutubeIcon,
    },
  };

  const renderIcon = (media: SocialMediaEnum, variant?: FooterVariant.Dark) => {
    const { blackIcon: BlackIcon, url, whiteIcon: WhiteIcon } = socialMediaMap[media];

    return (
      <IconContainer key={media}>
        <a
          href={url}
          onClick={() => {
            sendGA4Tracking({
              action: "click",
              category: "footer",
              customized_parameters: {
                link_name: media,
                social_platform: media,
              },
              subcategory: "",
            });
          }}
          rel="noopener noreferrer"
          target="_blank"
          title="Follow SCMP"
        >
          {variant === FooterVariant.Dark ? <WhiteIcon /> : <BlackIcon />}
        </a>
      </IconContainer>
    );
  };

  return (
    <Container className={className}>
      {[
        SocialMediaEnum.Facebook,
        SocialMediaEnum.Twitter,
        SocialMediaEnum.Youtube,
        SocialMediaEnum.Instagram,
        SocialMediaEnum.Linkedin,
      ].map(media => renderIcon(media, variant))}
    </Container>
  );
};

FooterSocialMedia.displayName = "FooterSocialMedia";
